import { createContext, createElement, useContext, type ComponentType } from 'react'

/** Stable identity only. Labels and permissions are resolved by the source backend. */
export interface ExternalRecordReference {
  moduleId: string
  recordType: string
  recordId: string
}

export interface ModuleSurfaceProps {
  source: ExternalRecordReference
  onDirtyChange: (dirty: boolean) => void
  onBusyChange: (busy: boolean) => void
  onCompleted?: () => void
}

export interface ModuleSurfaceDefinition {
  title: string
  /** Contextual surfaces authorize each request against the source record. */
  access?: 'module' | 'contextual'
  load: () => Promise<{ default: ComponentType<ModuleSurfaceProps> }>
}

export interface ModuleSurfaceRequest {
  moduleId: string
  surfaceId: string
  recordType: string
  recordId: string
  presentation?: 'inline' | 'dialog'
  open?: boolean
  onOpenChange?: (open: boolean) => void
  onCompleted?: () => void
}

export const ModuleSurfaceRendererContext =
  createContext<ComponentType<ModuleSurfaceRequest> | null>(null)

/** The shell owns loading, API context, the dialog and error isolation. */
export function ModuleSurface(props: ModuleSurfaceRequest) {
  const renderer = useContext(ModuleSurfaceRendererContext)
  return renderer ? createElement(renderer, props) : null
}
